export default __webpack_public_path__ + "static/media/petroecuador-logo.d4ff8543.png";